import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Blog } from '../common/Blog';
import { ApiServiceBase } from './ApiServiceBase';
import { defaultDateRange, toApiDate } from '../common/date-helpers';
import { BlogFilter } from '../common/BlogFilter';
import { PagedResult, PagingParams, pagingToHttpParams } from '../common/PagedResult';

@Injectable({
  providedIn: 'root',
})
export class BlogService extends ApiServiceBase {

  protected readonly path = 'blog';

  getDefaultFilter(): BlogFilter {
    const { from, to } = defaultDateRange();
    return new BlogFilter(from, to);
  }

  create(blog: Blog): Observable<Blog> {
    return this.http
      .post<Blog>(this.getUrl(), blog);
  }

  getById(id: string): Observable<Blog> {
    return this.http.get<Blog>(this.getUrl() + '/' + id);
  }

  getBySearch(dateFrom?: Date, dateTo?: Date, paging?: PagingParams): Observable<PagedResult<Blog>> {
    return this.http
      .get<PagedResult<Blog>>(this.getUrl() + '/forcustomer', {
        params: {
          dateFrom: toApiDate(dateFrom),
          dateTo: toApiDate(dateTo),
          ...pagingToHttpParams(paging),
        },
      });
  }

  // Dead endpoint: backend route GET /api/blog/ofparenttenant does not exist. Reevaluate later.
  getLatestOfParentTenant(): Observable<Blog> {
    return this.http
      .get<Blog>(this.getUrl() + '/ofparenttenant');
  }

  // Dead endpoint: backend route GET /api/blog/ofcarrier does not exist. Reevaluate later.
  getLatestOfCarrier(): Observable<Blog> {
    return this.http
      .get<Blog>(this.getUrl() + '/ofcarrier');
  }

  update(id: string, blog: Blog): Observable<Blog> {
    return this.http
      .put<Blog>(this.getUrl() + '/' + id, blog);
  }
}
